
const LigneFactureCollection = function(element, hasRemise) {
    this.element = $(element);
    this.hasRemise = hasRemise;
    this.add = this.element.find('[data-add-line]');
    this.tbody = this.element.find('table tbody');
    this.tfoot   = this.element.find('table tfoot');
    this.client = this.element.closest('form').find('[name$="\[client\]"]');

    this.add.on('form-success.modal', (event, response) => {
        let row = this.initRow();
        this.updateRow(row, response);
    });

    this.tbody.on('before-load.modal', '[data-edit]', (event, requestData) => {
        this.setEditData($(event.currentTarget).closest('tr'), requestData)
    });
    this.tbody.on('form-success.modal', '[data-edit]', (event, response) => {
        this.updateRow($(event.currentTarget).closest('tr'), response);
    });

    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();
    });

    /// Mise à jour donnée dans le tableau
    this.tbody.on('keyup change', 'input', event => {
        this.updateTotalRow($(event.currentTarget).closest('tr'));
    });

    /// Fix calculs initiaux (validation échouée)
    this.tbody.find('tr').each((index, element) => {
        var row = $(element);

        if (row.find('[name$="\[totalHT\]"]').val() == '') {
            this.updateTotalRow(row);
        }
    })
};

$.extend(LigneFactureCollection.prototype, {
    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = 0;

        // Find max name
        this.element.find('[data-name]').each(function() {
            let n = parseInt($(this).attr('data-name'));

            if (n >= name) {
                name = n + 1;
            }
        });

        prototype = prototype.replace(/__name__/g, name);

        return $(prototype).appendTo(this.tbody);
    },

    updateRow: function(row, data) {
        let prixUnitaire = data.prixUnitaire / 100,
            quantiteUnitaire = data.quantiteUnitaire,
            quantite = data.quantite,
            prix = data.prix / 100
        ;

        row.attr('data-ligne-kgs', data.isKGS ? '1' : '0');

        row.find('[data-designation]').text(data.designation);

        row.find('[name$="\[famille\]"]').val(data.famille.id);
        row.find('[name$="\[origine\]"]').val(data.origine ? data.origine.id : '');
        row.find('[name$="\[calibre\]"]').val(data.calibre ? data.calibre.id : '');
        row.find('[name$="\[variete\]"]').val(data.variete ? data.variete.id : '');
        row.find('[name$="\[qualite\]"]').val(data.qualite ? data.qualite.id : '');

        row.find('[name$="\[ratioQuantitePoids\]"]').val(data.ratioQuantitePoids);
        row.find('[name$="\[quantiteUnitaire\]"]').formatFloat(quantiteUnitaire);
        row.find('[name$="\[quantite\]"]').formatFloat(quantite);

        row.find('[name$="\[prixUnitaire\]"]').formatMoney(prixUnitaire);
        row.find('[name$="\[prix\]"]').formatMoney(prix);

        row.find('[name$="\[uniteVente\]"]').val(data.uniteVente);

        row.find('[name$="\[tauxTVA\]"]').val(data.tauxTVA);

        if (this.hasRemise) {
            const remise = row.find('[name$="\[remise\]"]');
            if (remise.val() == '') {
                remise.formatFloat(0.);
            }
        }

        this.updateTotalRow(row);
    },

    updateTotalRow: function(row) {
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney(),
            totalHT = prixUnitaire * quantiteUnitaire,
            tauxTVA = row.find('[name$="\[tauxTVA\]"]').parseFloat(),
            totalTTC = totalHT * (1.0 + tauxTVA);

        if (this.hasRemise) {
            let remise = (row.find('[name$="\[remise\]"]').parseFloat() / 100.) || 0.;

            totalHT *= (1. - remise);
        }

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);
        row.find('[name$="\[totalTTC\]"]').formatMoney(totalTTC);

        // Refresh quantite KGS if line is KGS
        if (row.attr('data-ligne-kgs') === '1') {
            row.find('[name$="\[quantite\]"]').formatFloat(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').val(prixUnitaire);
        }

        this.updateTotalFooter();
    },

    updateTotalFooter: function() {
        let totalHT = 0, totalTTC = 0;

        this.tbody.find('tr').each(function() {
            const $tr = $(this);

            totalHT  += $tr.find('[name$="\[totalHT\]"]').parseMoney();
            totalTTC += $tr.find('[name$="\[totalTTC\]"]').parseMoney();
        });

        this.tfoot.find('[data-total-ht]').formatMoney(totalHT);
        this.tfoot.find('[data-total-tva]').formatMoney(totalTTC - totalHT);
        this.tfoot.find('[data-total-ttc]').formatMoney(totalTTC);
    },

    setEditData: function(row, requestData) {
        requestData.famille = row.find('[name$="\[famille\]"]').val();
        requestData.origine = row.find('[name$="\[origine\]"]').val();
        requestData.calibre = row.find('[name$="\[calibre\]"]').val();
        requestData.variete = row.find('[name$="\[variete\]"]').val();
        requestData.qualite = row.find('[name$="\[qualite\]"]').val();
        requestData.designation = row.find('[name$="\[designation\]"]').val();
        requestData.quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat();
        requestData.prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseFloat() * 100;
    }
});

const ligneFactureCollection = () => {
    $(document).arrive('[data-ligne-facture-collection]', {
        existing: true
    }, function() {
        new LigneFactureCollection(this, true);
    });
};

export { ligneFactureCollection }


// WEBPACK FOOTER //
// ./js/form/ligneFactureCollection.js